import store from "../../store";
import {
  fetchAllOpportunities,
  fetchAllAccounts,
  fetchAllOpportunityStages,
  fetchOpportunityByID,
  createOpportunityService,
  createAccountService,
} from "./pipelineServices";

import { fetchAllDocumentTypes } from "../DocumentActions/services";

import {
  convertOpportunitiesIntoPipeLineData,
  getOppswithAccountData,
} from "./pipelineMethods";

export const getPipelineInitData = () => async dispatch => {
  try {
    await Promise.all([
      fetchAllOpportunities(),
      fetchAllAccounts(),
      fetchAllOpportunityStages(),
      fetchAllDocumentTypes(),
    ])
      .then(response => {
        const newOpps = getOppswithAccountData(
          response[0].Opportunities,
          response[1].Accounts,
        );
        const pipelineData = convertOpportunitiesIntoPipeLineData(newOpps);
        const payloadData = {
          pipelineData,
          newOpps,
          response,
        };
        dispatch({
          type: "PIPELINE_INIT_DATA",
          payload: payloadData,
        });
      })
      .catch(error => {
        console.error(`pipelineActions => getPipelineInitData => ${error}`);
        throw error;
      });
    return null;
  } catch (error) {
    throw error;
  }
};

export const getOpportunityById = oppId => dispatch =>
  new Promise((resolve, reject) => {
    fetchOpportunityByID(oppId)
      .then(response => {
        dispatch({
          type: "OPPORTUNITIES_BY_ID",
          payload: response.Opportunity,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`pipelineActionss => getAllOpportunities => ${error}`);
        reject(error);
      });
  });

export const getOpportunitiesForPipeline = opportunities => dispatch => {
  const convertedOpps = convertOpportunitiesIntoPipeLineData(opportunities);
  dispatch({
    type: "PIPELINE_OPPORTUNITIES_DATA",
    payload: convertedOpps,
  });
};

export const filterPipelineData = (filters, accounts) => dispatch =>
  new Promise((resolve, reject) => {
    fetchAllOpportunities(filters)
      .then(response => {
        const newOpps = getOppswithAccountData(
          response.Opportunities,
          accounts,
        );
        const pipelineData = convertOpportunitiesIntoPipeLineData(newOpps);
        const payloadData = {
          pipelineData,
          opportunities: newOpps,
        };
        dispatch({
          type: "PIPELINE_FILTERED_OPPORTUNITIES_DATA",
          payload: payloadData,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(
          `pipelineActionss => getFilteredOpportunitiesForPipeline => ${error}`,
        );
        reject(error);
      });
  });

export const deleteDocumentAction =
  (docID, oppsByAccount, allOpportunities, deletedExtQuote) => dispatch => {
    // remove deleted document from opportunities
    const updatedAllOpportunities = allOpportunities.map(opportunity => {
      const tempOpportunity = { ...opportunity };
      let updateExtQuotes = [];
      const filteredDocs = [];
      // remove the deleted doc from the opportunity's docs and
      // add the removed external quote in opportunity's external_quotes
      opportunity.docs.forEach(doc => {
        if (doc.id === docID) {
          if (deletedExtQuote && deletedExtQuote.length > 0) {
            updateExtQuotes = [...tempOpportunity.external_quotes];
            updateExtQuotes.push(deletedExtQuote[0]);
            tempOpportunity.external_quotes = updateExtQuotes;
          }
        } else {
          filteredDocs.push(doc);
        }
      });
      tempOpportunity.docs = filteredDocs;
      return tempOpportunity;
    });

    let pipelineData = [];
    // If no opportunity is selected
    if (oppsByAccount.length === 0) {
      pipelineData = convertOpportunitiesIntoPipeLineData(
        updatedAllOpportunities,
      );
    }
    // If an opportunity is selected
    else {
      pipelineData = convertOpportunitiesIntoPipeLineData(oppsByAccount);
    }

    const payloadData = {
      pipelineData,
      opportunities: updatedAllOpportunities,
    };

    dispatch({
      type: "DELETE_DOCUMENT",
      payload: payloadData,
    });
  };

export const createOpportunity = (oppo, calledFromAssetsPage) => dispatch =>
  new Promise((resolve, reject) => {
    createOpportunityService(oppo)
      .then(response => {
        const reduxState = store.getState();
        if (calledFromAssetsPage) {
          const { accountDocs, accounts } = reduxState.OldAssetStore;
          const accountDoc = {
            crm_opportunity: getOppswithAccountData(
              response.Opportunity,
              accounts,
            ),
            documents: [],
          };
          dispatch({
            type: "UPDATE_ACCOUNT_DOCS",
            payload: [...accountDocs, accountDoc],
          });
        } else {
          const { opportunities, accounts } = reduxState.PipelineStore;
          dispatch({
            type: "UPDATE_OPPORTUNITIES",
            payload: [
              getOppswithAccountData(response.Opportunity, accounts),
              ...opportunities,
            ],
          });
        }
        resolve("success");
      })
      .catch(error => {
        console.debug("pipelineActions =>", error);
        reject(error);
      });
  });

export const createAccount = (account, calledFromAssetsPage) => dispatch =>
  new Promise((resolve, reject) => {
    createAccountService(account)
      .then(response => {
        const reduxState = store.getState();
        if (calledFromAssetsPage) {
          const { accounts } = reduxState.OldAssetStore;
          dispatch({
            type: "UPDATE_ACCOUNTS_IN_ASSETS",
            payload: [response.Account, ...accounts],
          });
        } else {
          const { accounts } = reduxState.PipelineStore;
          dispatch({
            type: "UPDATE_ACCOUNTS",
            payload: [response.Account, ...accounts],
          });
        }

        resolve(response);
      })
      .catch(error => {
        console.debug("pipelineActions =>", error);
        reject(error);
      });
  });
